export class FilterBenefitGroup{
    description!: string;
}